const $ = jQuery;

export function hide(element) {
  if (element.style.display != 'none') {
    element.dataset.origDisplay = element.style.display;
  }
  element.style.display = 'none';
}

export function rotatingFadeText(element) {
  const jq_element = $(element);
  let text = jq_element.html().trim();
  jq_element.html('');
  let animationDuration = text.length * 400;
  for (let i = 0; i < text.length; i++) {
    let character = $('<span class="char">' + text[i] + '</span>');
    character.css('animation-delay', (i * 100) + 'ms');
    character.css('animation-duration', animationDuration + 'ms');
    jq_element.append(character);
  }
  jq_element.append('<div class="bar"></div>');
}

export function show(element, value = null) {
  if (value == null) {
    value = element.dataset.origDisplay;
    if (value === undefined) {
      value = 'block';
    }
  }
  element.style.display = value;
}

export const effects = {
  hide: hide,
  rotatingFadeText: rotatingFadeText,
  show: show,
};
